import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d3f9141a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f9141a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3f9141a')) {
      api.createRecord('d3f9141a', component.options)
    } else {
      api.reload('d3f9141a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d3f9141a&scoped=true&", function () {
      api.rerender('d3f9141a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormItem/TUpload/index.vue"
export default component.exports